import CreateWindow from "./fullscreenModal.js";
import logo from "./Aloitusruutu_Logo_Korjattu.png";
import bg from "./aloitusruutu_Tausta.jpg";
import { html, render } from "lit-html";
import instructions from "./Aloitusruutu_ohjeet_deskari.png";
import lozad from "lozad";
import hiiri from "./hiiri.png";
import kb from "./Nuolet.png";
import esc from "./esc.png";
import { tips } from "~src/tips/index.js";
import { mobileOrNot } from "~/src/helpers/mobileDetect.js";
import "./startingScreen.css";

import {fullScreen} from "../helpers/fullScreen"
import { countUpTimer } from "../helpers/countUpTimer.js";
import { registerEvent } from "../helpers/analyticsMethods.js";
import { disableBodyScroll } from "body-scroll-lock";
import { iOSallowScroll } from "../helpers/iOSHacks.js";
import rotatePic from "./Navi_rotate.png";
import movePic from "./Navi_liikkuminen.png";
import { resizeJobs } from "../helpers/windowResize.js";
import pointerLockEvents from "../helpers/pointerLockEvents.js";
import { pickText } from "../textcontents.js";
export const StartScreenImages = [hiiri, kb, esc, rotatePic, movePic] //for preloading in assetsManager
export let everythingReady = () => null;

let introductionEnabled = false;
let startScroller;


pickText("start", "1")

const intro = (sceneLoaded, exitcallback, engine) => {
  if (!introductionEnabled)
    return html`
      <div class="startingscreen-introduction" style=${sceneLoaded ? "opacity: 1" : "opacity: 0"}>
        <p>${pickText("start", "1")}</p>
        <p>
        ${pickText("start", "2")}
        </p>

        <p>${pickText("start", "3")}</p>
        <div
          id="start-button"
          @click="${() => {
            introductionEnabled = true;
            everythingReady();
            startScroller?.scrollTo(0,0)
          }}}"
        >
        ${pickText("start", "8a")}
        </div>
      </div>
    `;
  else if (introductionEnabled)
    return html`
          <div class="startingscreen-introduction" style="opacity: 0; ${!mobileOrNot() ? `position: relative; top:50%; transform: translateY(-50%)`: ""}  ">
          <div class="instructions-row">
            <div class="instructions-col">
              <img src=${mobileOrNot() ? movePic : kb } />
              <p>${pickText("start", "6a")}</p>
            </div>
            <div class="instructions-col">
              <img src=${mobileOrNot() ? rotatePic : hiiri } />
              <p>${pickText("start", "6b")}</p>
            </div>
          </div>
          <p class="esc-instruction">
           ${mobileOrNot() ? pickText("start", "5") : html`${pickText("start", "7a")}
            <img src=${esc} class="esc-image" />${pickText("start", "7b")}`}
          </p>
                <div id="start-button" @click=${() => {
                  
                  exitcallback();
                  tips.gameStarted.setTime(10);
                  tips.matrixPoster.setTime(60);
                  BABYLON.Engine.audioEngine.unlock();
                  engine?.resize() 
                  if(true) {
                // fullScreen();
                  document.addEventListener('fullscreenchange', (event) => {
                    if (document.fullscreenElement) {
                      engine?.resize()
                    } else {
                      engine?.resize()
                    }
                  });
                 }
                registerEvent("AloitaNappi") 
                resizeJobs();
                pointerLockEvents.lockPointerToCanvas();
            }}>
              ${pickText("start", "8b")}
                </div>
        </div></div>`;
};

export const StartingScreen = function (engine, logoImg) {
  // CreateWindow palauttaa modaali-ikkunan noden, johon siis rendataan
  const fullscreenWindow = CreateWindow({});
  if(window.location.href.indexOf("svenska") > -1) {
    logoImg = "https://svenska-dataviz.ylestatic.fi/2020-12-trollets-bunker/logo_svenska.png"
  }
  const markup = (bgloaded, sceneLoaded, exitcallback) => html`
    <div
      class=${bgloaded
        ? "startingscreen-container loaded"
        : "startingscreen-container"}
      style=${`background-image: url(${bg}); ${
        !sceneLoaded ? "overflow: hidden" : ""
      } `}
    >
      <div class="startingscreen-content ${bgloaded ? "loaded" : ""}">
        ${!introductionEnabled ? html`<img src=${logoImg ? logoImg : logo } class="trollibunkkeri-logo" />` : null}
        ${!sceneLoaded
          ? html`<div class="startingscreen-introduction">
              <div id="percent-rooms">
                <p id="loadingScreenPercentImages"></p>
                <p id="loadingScreenPercentFlat"></p>
                <p id="loadingScreenPercentWarehouse"></p>
                <p id="loadingScreenPercentBunker"></p>
              </div>
              <p id="all-loaded"></p>
            </div>`
          : ``}
        ${intro(sceneLoaded, exitcallback)}
      </div>
    </div>
  `;


  let loadFinished = false;
  var img = new Image();

  const callback = () => {
    loadFinished = true;
    render(markup(true, false), fullscreenWindow.element);
  };

  img.addEventListener("load", callback, { passive: true });
  img.src = bg;

  if (img.complete) callback();
  everythingReady = () => {
    render(markup(true, true, fullscreenWindow.exit), fullscreenWindow.element);
    if(document.querySelector("#click-with-mouse")){
    document.querySelector("#click-with-mouse").style.display = "block";
    }
    // and remove 'faded-out' in order to fade-in our element
      requestAnimationFrame(() => {
        document.querySelector(
          ".startingscreen-introduction"
        ).style.opacity = 1;
      });
  };
 
  
  registerEvent("Aloitussivu") 


  render(markup(loadFinished, false), fullscreenWindow.element);

  startScroller = iOSallowScroll(".startingscreen-content")
};
